<div class="container-main">
  <div>
    <mat-tab-group mat-align-tabs="start">
      <mat-tab>
        <ng-template mat-tab-label
          ><span data-tour="alertas.dash.tab-alertas"
            >Estadísticas de alerta</span
          ></ng-template
        >
        <div class="row">
          <div class="col-8" data-tour="alertas.dash.resumen">
            <mini-cards></mini-cards>
            <bar-new-closed></bar-new-closed>
            <bar-priority-alert></bar-priority-alert>
          </div>
          <div class="col-4" data-tour="alertas.dash.estado">
            <alert-status-percentage></alert-status-percentage>
            <alert-by-channel></alert-by-channel>
          </div>
          <div class="col-12" data-tour="alertas.dash.ultimas">
            <resume-last-alert-table></resume-last-alert-table>
          </div>
        </div>
      </mat-tab>
      <mat-tab>
        <ng-template mat-tab-label
          ><span data-tour="alertas.dash.tab-trabajo"
            >Estadísticas de trabajo</span
          ></ng-template
        >
        <div class="row">
          <div class="col-12">
            <asigned-vs-solved></asigned-vs-solved>
          </div>
          <div class="col-3">
            <alert-time-response-resolution></alert-time-response-resolution>
          </div>
          <div class="col-9">
            <alert-bar-reasigned></alert-bar-reasigned>
          </div>
        </div>
      </mat-tab>
    </mat-tab-group>
    <!-- <resume-filter *ngIf="!userService.isRas"></resume-filter> -->

    <!-- <div >
      <div class="row content">
        <div class="col-8">
          <div class="row indicator-content">
            <div class="col indicator" *ngFor="let indicator of indicators">
              <resume-indicator-card
                [indicator]="indicator"
              ></resume-indicator-card>
            </div>
          </div>
          <div class="row">
            <div class="col-6 chart-left">
              <resume-in-process-chart></resume-in-process-chart>
            </div>
            <div class="col-6 chart-right">
              <resume-finished-chart></resume-finished-chart>
            </div>
          </div>
        </div>
        <div class="col-4 type-cases">
          <resume-type-cases></resume-type-cases>
        </div>
      </div>
      <div>
        <resume-last-cases-table></resume-last-cases-table>
      </div>
      <div>
        <resume-line-chart></resume-line-chart>
      </div>
    </div> -->
  </div>
</div>
